<template>
  <div class="dropdown">
    <button
      class="user-menu__trigger"
      type="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      aria-label="Abrir menú de usuario"
      title="Menú de usuario"
    >
      <span class="user-menu__avatar" aria-hidden="true">{{ initials }}</span>
      <span v-if="showLabel" class="user-menu__name">{{ displayName }}</span>
      <i v-if="showLabel" class="fa-solid fa-chevron-down user-menu__chevron" aria-hidden="true"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end user-menu__dropdown">
      <li class="user-menu__identity">
        <strong>{{ displayName }}</strong>
        <span v-if="company">{{ company }}</span>
      </li>
      <li><hr class="dropdown-divider"></li>
      <li>
        <router-link class="dropdown-item" to="/perfil">
          <i class="fa-solid fa-user" aria-hidden="true"></i>
          Mi perfil
        </router-link>
      </li>
      <li>
        <router-link class="dropdown-item" to="/perfil">
          <i class="fa-solid fa-sliders" aria-hidden="true"></i>
          Configuración personal
        </router-link>
      </li>
      <li><hr class="dropdown-divider"></li>
      <li>
        <button class="dropdown-item text-danger" type="button" @click="$emit('logout')">
          <i class="fa-solid fa-right-from-bracket" aria-hidden="true"></i>
          Cerrar sesión
        </button>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { AuthUser } from '@/store'

const props = withDefaults(defineProps<{
  user: AuthUser | null
  showLabel?: boolean
}>(), {
  showLabel: true
})

defineEmits<{ (event: 'logout'): void }>()

const displayName = computed(() => {
  const name = props.user?.full_name?.trim()
  if (name) return name
  return props.user?.email?.split('@')[0] || 'Usuario'
})

const initials = computed(() => displayName.value
  .split(/\s+/)
  .slice(0, 2)
  .map((part) => part.charAt(0).toUpperCase())
  .join(''))

const company = computed(() =>
  props.user?.organization?.trim() ||
  props.user?.receipt_profile?.business_name?.trim() ||
  props.user?.receipt_profile?.legal_name?.trim() ||
  ''
)
</script>

